// Written in this round about way for babel-transform-imports
import Prompt from 'react-router/es/Prompt';

export default Prompt;


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/es/Prompt.js
// module id = 1166
// module chunks = 0